import React, { useState } from 'react';
import { Box, Text, Stack, Checkbox, Badge, Button, IconButton, HStack, Divider } from '@chakra-ui/react';
import { FaCalendarAlt } from 'react-icons/fa';

const TodoList = () => {
    const [todos, setTodos] = useState([
        {
            id: 1,
            title: 'Send Reminder to Students',
            time: '01:00 PM',
            status: 'Completed',
            checked: true,
        },
        {
            id: 2,
            title: 'Create Routine to new staff',
            time: '04:50 PM',
            status: 'Inprogress',
            checked: false,
        },
        {
            id: 3,
            title: 'Extra Class Info to Students',
            time: '04:55 PM',
            status: 'Yet To Start',
            checked: false,
        },
        {
            id: 4,
            title: 'Fees for Upcoming Academics',
            time: '04:55 PM',
            status: 'Yet To Start',
            checked: false,
        },
        {
            id: 5,
            title: 'English - Essay on Visit',
            time: '05:55 PM',
            status: 'Yet To Start',
            checked: false,
        },
    ]);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Completed':
                return <Badge borderRadius='full' colorScheme="green" fontSize='11px'>Completed</Badge>;
            case 'Inprogress':
                return <Badge borderRadius='full' colorScheme="blue" fontSize='11px'>Inprogress</Badge>;
            case 'Yet To Start':
                return <Badge borderRadius='full' colorScheme="yellow" fontSize='11px'>Yet To Start</Badge>;
            default:
                return null;
        }
    };

    const handleCheck = (id) => {
        setTodos(
            todos.map((todo) =>
                todo.id === id ? { ...todo, checked: !todo.checked } : todo
            )
        );
    };

    return (
        <Box p={4} borderWidth="1px" borderRadius="lg" overflow="hidden">
            <HStack mb={4} justifyContent="space-between">
                <Text fontSize="lg" fontWeight="bold">Todo</Text>
                <HStack>
                    <IconButton
                        aria-label="Calendar"
                        icon={<FaCalendarAlt />}
                        size="sm"
                        variant="ghost"
                    />
                    <Button size="sm" variant="link">
                        Today
                    </Button>
                </HStack>
            </HStack>
            <Divider />
            <Stack spacing={4} mt={4}>
                {todos.map((todo, index) => (
                    <React.Fragment key={todo.id}>
                        <HStack justifyContent="space-between">
                            <Checkbox
                                isChecked={todo.checked}
                                onChange={() => handleCheck(todo.id)}
                                colorScheme="blue"
                            >
                                <Text
                                    as={todo.checked ? 'del' : 'span'}
                                    fontWeight="semibold"
                                    color={todo.checked ? 'gray.500' : '#202C4B'}
                                >
                                    {todo.title}
                                </Text>
                                <Text fontSize="sm" color="gray.500">
                                    {todo.time}
                                </Text>
                            </Checkbox>
                            {getStatusBadge(todo.status)}
                        </HStack>

                        {/* Add a Divider after every todo except the last one */}
                        {index < todos.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </Stack>
        </Box>
    );
};

export default TodoList;
